module.exports = __webpack_public_path__ + "media/images/badge-packing-active-f9eeab1465c34ed665c032813990e122.svg";